
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"24","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 9.5h22m0 0L14.75 1M23 9.5L14.75 18","stroke":"#5A5A5A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
      }
    
      }
    